export const shared = {
    namespaced: true,
    state: {
        isMenuActive: false,
        isDropdownOpen: false,
        stripeKey: process.env.MIX_STRIPE_KEY,
        stripeOptions: {
            hidePostalCode: true,
            style: {
                base: {
                    color: '#5E5E5E',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    fontWeight: '300',
                    '::placeholder': {
                        color: '#5E5E5E',
                        fontFamily: 'Montserrat, sans-serif',
                    }
                },
                invalid: {
                    color: '#E64022',
                    iconColor: '#E64022'
                }
            }
        }
    },
    getters: {
    },
    mutations: {
        setMenuActiveState(state, payload) {
            state.isMenuActive = payload.value;
        },
        setDropdownOpenState(state, payload) {
            state.isDropdownOpen = payload.value;
        }
    },
    actions: {
        toggleMenuState(context, payload) {
            context.commit('setMenuActiveState', payload)
        },
        toggleDropdownState(context, payload) {
            context.commit('setDropdownOpenState', payload);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/shared.js